module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part"
  }, [_c('strong', [_vm._v("The Beginning")])]), _vm._v(" "), _c('div', {
    staticClass: "note5"
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('em', [_vm._v("“I have always been willing to take the blame for the things I have done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("—Lillie Langtry")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-774ea401","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/p01.vue
// module id = 75
// module chunks = 0